// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/management/resources/tenant.proto (package gx.management.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";

/**
 * Describes the file services/management/resources/tenant.proto.
 */
export const file_services_management_resources_tenant = /*@__PURE__*/
  fileDesc("CipzZXJ2aWNlcy9tYW5hZ2VtZW50L3Jlc291cmNlcy90ZW5hbnQucHJvdG8SF2d4Lm1hbmFnZW1lbnQucmVzb3VyY2VzIuwBCg5UZW5hbnRSZXNvdXJjZRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhMKBmRvbWFpbhgDIAEoCUgAiAEBEjAKBnN0YXR1cxgEIAEoDjIgLmd4LmRhdGFiYXNlLm1vZGVscy5UZW5hbnRTdGF0dXMSHgoWd29ya29zX29yZ2FuaXphdGlvbl9pZBgFIAEoCRIXCgphdmF0YXJfdXJsGAYgASgJSAGIAQESFwoKYXZhdGFyX2hleBgHIAEoCUgCiAEBQgkKB19kb21haW5CDQoLX2F2YXRhcl91cmxCDQoLX2F2YXRhcl9oZXhC8wEKG2NvbS5neC5tYW5hZ2VtZW50LnJlc291cmNlc0ILVGVuYW50UHJvdG9QAVpJZ2l0aHViLmNvbS9nYWxheHktaW8vZ3gvc2hhcmVkL2dvL2NvbnRyYWN0cy9zZXJ2aWNlcy9tYW5hZ2VtZW50L3Jlc291cmNlc6ICA0dNUqoCF0d4Lk1hbmFnZW1lbnQuUmVzb3VyY2VzygIXR3hcTWFuYWdlbWVudFxSZXNvdXJjZXPiAiNHeFxNYW5hZ2VtZW50XFJlc291cmNlc1xHUEJNZXRhZGF0YeoCGUd4OjpNYW5hZ2VtZW50OjpSZXNvdXJjZXNiBnByb3RvMw", [file_services_database_models_public]);

/**
 * Describes the message gx.management.resources.TenantResource.
 * Use `create(TenantResourceSchema)` to create a new message.
 */
export const TenantResourceSchema = /*@__PURE__*/
  messageDesc(file_services_management_resources_tenant, 0);

